<template>
  <div class="info">
    <p class="textInfo">
      <span v-html="surveyQuestion.longCaption" />
    </p>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('survey')

export default {
  name: 'Info',
  computed: {
    ...mapGetters(['surveyQuestion']),
  },
}
</script>

<style scoped lang="postcss">
.textInfo {
  text-align: left;
}
</style>
